import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-162" data-mp="30n63oxoxunr">
      <div className="absolute inset-0 bg-stadium-glow opacity-50 pointer-events-none" data-id="element-163" data-mp="31y9vor4z2ev"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-164" data-mp="3lc9uh9usqbg9">
        <div className="max-w-4xl mx-auto text-center" data-id="element-165" data-mp="3qdz7gv1kwz6z">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-166" data-mp="hxnlcsyp3x5c">
            <h2 className="font-anton text-4xl md:text-6xl text-gold-500 uppercase tracking-wide mb-4" data-id="element-167" data-mp="81asfxaz5nbn">
              LA SOLUTION QUE VOUS ATTENDIEZ
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-white uppercase tracking-widest mb-12" data-id="element-168" data-mp="2sonsu754pgw1">
              UN SYSTÈME D'ENTRAÎNEMENT COMPLET EN 6 VOLUMES
            </h3>
            <p className="text-xl text-gray-300 font-medium mb-12" data-id="element-169" data-mp="2x95xj5fx1a9u">
              Conçu spécifiquement pour les entraîneurs de football.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="mb-16 relative" data-id="element-170" data-mp="377u2b2iw3svl">
            <div className="absolute -inset-4 bg-gold-500/10 blur-2xl rounded-full" data-id="element-171" data-mp="3c7zwoqgjnthd"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rABxCQatGKhTqbYxT5LdU1/M_-2.webp" alt="Football Prêt : Système 365 — 6 volumes puissants, un système complet" loading="lazy" decoding="async" className="relative w-full max-w-3xl mx-auto h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-172" data-mp="3pz4o559rdfgm" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="prose prose-lg prose-invert mx-auto text-gray-300" data-id="element-173" data-mp="5w9vvmkv743v">
            <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-174" data-mp="kmheq3esap53">
              FOOTBALL PRÊT : SYSTÈME 365 est bien plus qu'un manuel
              d'entraînement.
            </p>
            <p className="mb-8 leading-relaxed" data-id="element-175" data-mp="tj9n49afp1t4">
              C'est un véritable système complet pour entraîneurs, qui vous
              donne un développement structuré des joueurs, des séances prêtes à
              l'emploi, une progression tactique, des outils de planification de
              saison, des systèmes d'évaluation et des ressources de gestion
              pour l'entraîneur.
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 font-oswald text-xl text-gold-400 uppercase tracking-wider" data-id="element-176" data-mp="35cgie0osqc1w">
              <span data-id="element-177" data-mp="2t04fu0ffd5x6">✓ Tout est organisé.</span>
              <span data-id="element-178" data-mp="2syb5ob5ls3kf">✓ Tout est structuré.</span>
              <span data-id="element-179" data-mp="2o0i27pvopnnu">✓ Tout est prêt à l'emploi.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}